import React from "react";
import { useParams, Navigate, useLocation } from "react-router";
import WindowRedirect from "../windowRedirect/WindowRedirect";

const supportedLocales = ["en", "sv"];
const defaultLocale = "sv";

export default function LocaleRouteGuard({ children }: { children: React.ReactNode }) {
  const { locale } = useParams();
  const location = useLocation();

  if (!locale || !supportedLocales.includes(locale)) {
    return <WindowRedirect url={`/${defaultLocale}${location.pathname}${location.search}`} />;
  }

  return <>{children}</>;
}